/* eslint-disable no-throw-literal */
import React, { createContext, useContext, useCallback, useMemo } from "react"
import Servo from "../services/servo"
import { useLocalStorage } from "./useLocalStorage"
import { auth } from "../firebase/firebaseConfig"

const ProfileContext = createContext()

export function ProfileProvider(props) {
  const [permiso, setPermiso] = useLocalStorage("permiso", {})
  const [usuario, setUsuario] = useLocalStorage("usuario", {})
  const clearUsuario = useCallback(() => {
    setUsuario(null)
    setPermiso(null)
  }, [setUsuario, setPermiso])
  const loadUsuario = useCallback(async () => {
    const uid = auth.currentUser?.uid
    const usuario = await Servo.get("profile")
    if (!uid || uid !== auth.currentUser?.uid) return false
    if (usuario?.cuerpo?.detalle?.estatus === 200) {
      setUsuario({ ...usuario?.cuerpo?.detalle?.usuario })
      setPermiso({ ...usuario?.cuerpo?.detalle?.permiso })
      return true
    } else {
      clearUsuario()
      if (usuario?.status === 403) {
        const error = new Error(usuario.message || "Tu cuenta no tiene acceso habilitado a Zonda")
        error.code = "zonda/access-denied"
        throw error
      }
      const error = new Error(usuario?.message || "No se pudo cargar el perfil de Zonda. Intenta nuevamente.")
      error.code = usuario?.status === 401 ? "zonda/session-invalid" : "zonda/profile-unavailable"
      throw error
    }
  }, [clearUsuario, setUsuario, setPermiso])

  const memData = useMemo(() => {
    return {
      usuario,
      permiso,
      loadUsuario,
      clearUsuario,
    }
  }, [usuario, permiso, loadUsuario, clearUsuario])
  return <ProfileContext.Provider value={memData} {...props} />
}

export function useProfile() {
  const context = useContext(ProfileContext)
  if (!context) {
    throw "error: auth context not defined."
  }
  return context
}
